import { IIdentifiable } from '@/common/models/models'
import { IStaff, Staff } from '@/common/models/data/dashboard/staff/staff'

interface IContactEntry extends IIdentifiable {
    email: string
    phone: string
    role: string
    staff_id: number

    staff: IStaff
}

class ContactEntry implements IContactEntry {
    id = 0
    email = ''
    phone = ''
    role = ''
    staff_id = 0

    staff = new Staff()

    constructor (dto?: IContactEntry) {
        if (dto) {
            this.id = dto.id
            this.email = dto.email
            this.phone = dto.phone
            this.role = dto.role
            this.staff_id = dto.staff_id

            this.staff = new Staff(dto.staff)
        }
    }
}

export {
    IContactEntry, ContactEntry
}
